import { useEffect, useState } from 'react';

import { TestimonialPayload } from '../types';
import { fetchTestimonials } from '../services/testimonialsService';

export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState<TestimonialPayload[]>([]);

  useEffect(() => {
    let isMounted = true;

    const loadTestimonials = async () => {
      try {
        const data = await fetchTestimonials();
        if (isMounted) {
          setTestimonials(data);
        }
      } catch (error) {
        console.error('Failed to load testimonials', error);
      }
    };

    loadTestimonials();

    return () => {
      isMounted = false;
    };
  }, []);

  return { testimonials };
};

